import { render, staticRenderFns } from "./ResourceOfHos.vue?vue&type=template&id=6be0a46e&scoped=true"
import script from "./ResourceOfHos.vue?vue&type=script&lang=js"
export * from "./ResourceOfHos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0a46e",
  null
  
)

export default component.exports